<template>
  <orders-tab />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import OrdersTab from '@/components/orders/OrdersTab';

export default {
  name: 'Orders',
  components: {
    OrdersTab,
  },
  created() {
    this.initializeWeekOrders({ office: this.user.office, weekNumber: this.weekNumber });
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
    ...mapState('weeklyMenu', { weekNumber: (state) => state.weekNumber }),
  },
  methods: {
    ...mapActions('orders', { initializeWeekOrders: 'initializeWeekOrders' }),
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminPage.vue